// extracted by mini-css-extract-plugin
export default {"container":"ModalInsert_container__PzCKM","mydivheader":"ModalInsert_mydivheader__eMvyw","mydiv":"ModalInsert_mydiv__Zvu3N","main":"ModalInsert_main__Skb+M"};